export default __webpack_public_path__ + "static/media/HoldIcon.9a789c8f.svg";